import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { LayoutFragmentsRenderComponent } from './layout-fragments-render.component';


export const components = [
  LayoutFragmentsRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: components
})
export class LayoutFragmentsRenderModule {}

export default components;
